export const ABOUT_URL = "/";
export const FAMILY_URL = "/משפחה";
export const WORK_URL = "/עבודה";
export const GROUND_URL = "/מקרקעין";
export const CONTACT_URL = "/צור קשר";
export const TEAM_URL = "/צוות המשרד";
export const LECTURES_URL = "/הרצאות";
export const STORIES_URL = '/כתבות';
export const RECOMMENDATIONS_URL = '/כתבו עלינו';